<ui-content-main [isWrappedInATab]="true" [hasTable]="true">
  <ui-content-main-header [title]="fileType.description" (searchChange)="search($event)">
  </ui-content-main-header>

  <ui-content-empty *ngIf="showMessageEmpty()"></ui-content-empty>

  <div class="container-table">
    <table *ngIf="!showMessageEmpty()" mat-table [dataSource]="dataSource">
      <!-- Icon Column -->
      <ng-container matColumnDef="iconLabel" sticky>
        <th mat-header-cell *matHeaderCellDef class="table-cell-icon">No.</th>
        <td mat-cell *matCellDef="let element" class="table-cell-icon">
          <i [ngClass]="fileType.id | fileTypeIcon: 'variant'"></i>
        </td>
      </ng-container>

      <!-- Name Column -->
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>Nombre</th>
        <td mat-cell *matCellDef="let element">
          <span class="table-text-strong">{{element.name}}</span>
          <span *ngIf="!isBachillerato" class="table-text table-text-suffix">{{element.name}}</span>
        </td>
      </ng-container>

      <!-- Actions Column -->
      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef>Acción</th>
        <td mat-cell *matCellDef="let element">
          <div class="table-actions">
            <i *ngIf="showLinkExternalFile(element)"
              class="fas fa-external-link-square icon-strong" (click)="downloadFile(element)">
            </i>
            <i *ngIf="!showLinkExternalFile(element) && !showLink" class="far fa-angle-right" (click)="showResource(element)">
            </i>
            <i *ngIf="showLink"
              class="fas fa-external-link-square icon-strong" (click)="refLink.click()">
            </i>
            <a href="{{element.urlContent}}" target="_blank" hidden #refLink>
            </a>
          </div>
        </td>
      </ng-container>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="table-row"></tr>
    </table>
  </div>

  <native-paginator (page)="changePage($event)" [length]="total" [pageSize]="node.sizePage">
  </native-paginator>

</ui-content-main>